import React, { createContext, FC, useEffect, useState } from 'react';

import { useGetEventByIdQuery } from '@/services';
import { ContextEvent } from '@/types';

type Props = {
  eventId: number;
  children: React.ReactNode;
};

type EventContextType = {
  eventData: ContextEvent;
  isEventLoading: boolean;
  refetch: () => void;
};

const defaultBehaviour: EventContextType = {
  eventData: null,
  isEventLoading: true,
  refetch: () => 0
};

export const EventContext = createContext<EventContextType>(defaultBehaviour);

export const EventProvider: FC<Props> = ({ eventId, children }) => {
  const [eventData, setEventData] = useState<ContextEvent>(null);
  const [isEventLoading, setIsEventLoading] = useState<boolean>(true);

  const { data, refetch } = useGetEventByIdQuery(eventId);

  useEffect(() => {
    if (data) {
      setEventData(data?.data);
      setIsEventLoading(false);
    }
  }, [data]);

  return (
    <EventContext.Provider value={{ eventData, isEventLoading, refetch }}>
      {children}
    </EventContext.Provider>
  );
};
